import {
  createClient as supabaseCreateClient,
  type SupabaseClient,
} from '@supabase/supabase-js'
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../../constants'
import { type Database } from '../../types/supabase'

let client: SupabaseClient<Database> | null = null
export const createClient = (): SupabaseClient<Database> => {
  //
  if (!client)
    client = supabaseCreateClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY)

  return client
}
